import React from "react";
import "./styles.css";

export default function LoadingDots(props) {
  return (
    <>
      <div className={"bouncing-loader"}>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </>
  );
}
